export default __webpack_public_path__ + "static/media/failure_x.0238e761.svg";